import { render } from "./Avatar.vue?vue&type=template&id=4c3b04f4&scoped=true"
import script from "./Avatar.vue?vue&type=script&lang=js"
export * from "./Avatar.vue?vue&type=script&lang=js"

import "./Avatar.vue?vue&type=style&index=0&id=4c3b04f4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4c3b04f4"

export default script